const itemEffectRef = (element, n) => {
  return $(element)
    .parent()
    .parent()
    .parent()
    .children(".card__inner")
    .children()
    .children(".media")
    .children("img")
    .eq(n);
};

$(".variant-images li:not(.more)").on("mouseover", function () {
  let imgIndex = $(this).index();
  itemEffectRef(this, imgIndex).css("opacity", 1).css("z-index", 10);
});
$(".variant-images li:not(.more)").on("mouseout", function () {
  let imgIndex = $(this).index();
  itemEffectRef(this, imgIndex).css("opacity", 0).css("z-index", 0);
  itemEffectRef(this, 0).css("opacity", 1).css("z-index", 1);
});

const fetchMyStore = async (query) => {
  const API_TOKEN = "05bcdc6d6e54deb0ace71783d83ffbc4";
  return await fetch(
    "https://supplybox-cardgame.myshopify.com/api/2024-04/graphql.json",
    {
      //[shop-name]にurlのショップ名を入力
      method: "POST",
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": API_TOKEN, //Storefront APIのアクセストークンを入力
      },
      body: query,
    }
  ).then((response) => response.json());
};

const suggestInit = () => {
  const titleList = (data) => {
    const list = data.map((item) => {
      return {
        label: `
          <div class="awesomplete-item-with-image">
            <img src="${item.node.featuredImage?.url || "noimage.jpg"}" alt="${
          item.node.title
        }" />
            <span>${item.node.title}</span>
          </div>
        `,
        value: item.node.title,
      };
    });
    return list;
  };

  const setQuery = (text) => {
    const query = `{
      products(first:250, query: "${text}") {
        edges {
          node {
            handle
            title
            featuredImage {
              url
            }
          }
        }
      }
    }`;
    return query;
  };

  const onSuggest = () => {
    const input = document.querySelector(".suggest-form-input");
    if (!input) return;

    const suggest = new Awesomplete(input, {
      minChars: 1,
      autoFirst: false,
      maxItems: 10,
      item: function (text, input) {
        const li = document.createElement("li");
        li.innerHTML = text.label;
        li.setAttribute("aria-label", text.value);
        return li;
      },
      replace: function (text) {
        this.input.value = text.value;
      },
    });

    input.addEventListener("input", (event) => {
      // document.body.classList.remove("body-lock");
      // document.querySelector(".hamburger").classList.remove("active");
      // document.querySelector(".drawer").classList.remove("open");
      fetchMyStore(setQuery(event.target.value)).then((response) => {
        const data = response.data.products.edges;
        suggest.list = titleList(data);
      });
    });

    input.addEventListener("awesomplete-select", (event) => {
      window.location.href = `/search?type=product&q=${event.text.value}`;
    });
  };

  onSuggest();
};

window.addEventListener("load", () => {
  suggestInit();
});
